import * as React from 'react';
const CustomDnbLogo = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.3 46" {...props}>
    <g data-name="Layer 2">
      <path
        d="M56.7 30a7.3 7.3 0 0 0 .6-3 5.49 5.49 0 0 0-2.1-4.4 4.1 4.1 0 0 0-1.1-.7l-.1-.1.1-.1a5.34 5.34 0 0 0 1.7-4.2 5.35 5.35 0 0 0-2.1-4.6 8.8 8.8 0 0 0-5-1.2h-6.2a.68.68 0 0 0-.7.7v20.5a.68.68 0 0 0 .7.7h7.1a9.83 9.83 0 0 0 5.4-1.4 8.7 8.7 0 0 0 1.7-2.2M43.9 13.8h4.9a6.45 6.45 0 0 1 3.8.9 3.28 3.28 0 0 1 1.2 2.9 3.16 3.16 0 0 1-3.4 3.5h-6.6v-7.3zm5.7 17.7h-5.8v-8.4h6.6c2.9 0 4.9 1.6 4.9 3.9 0 1.1 0 4.5-5.7 4.5m-13.3 2.1h.2a.55.55 0 0 0 .4-.6V0h-2v28.9L21.5 11.8a.55.55 0 0 0-.5-.3h-.2a.55.55 0 0 0-.4.6V46h2V16.3l13.4 17.1a.76.76 0 0 0 .5.2m-22.4-3.3a12.07 12.07 0 0 0 2.4-7.5c0-1.5-.2-5.1-2.4-7.8a8.4 8.4 0 0 0-3.4-2.5 10.5 10.5 0 0 0-3.9-.8H.7a.68.68 0 0 0-.7.7v20.5a.68.68 0 0 0 .7.7h5.9a9.2 9.2 0 0 0 3.8-.7 10 10 0 0 0 3.5-2.6m-7.3 1.2H2V13.8h4.6a7 7 0 0 1 5.7 2.5c1.8 2.2 1.9 5.5 1.9 6.5a10.46 10.46 0 0 1-1.9 6.2 7 7 0 0 1-5.7 2.5"
        className="custom_dnb_logo_svg__cls-1"
        data-name="Layer 1"
      />
    </g>
  </svg>
);
export default CustomDnbLogo;
